import { Section } from '@ui/library';

export interface StatsProps {
  /** Tuples of [number, label]. Editable in content/site.ts → stats. */
  items: ReadonlyArray<readonly [string, string]>;
}

export function Stats({ items }: StatsProps) {
  return (
    <Section tight className="stats-section">
      <div className="stats">
        {items.map(([n, l]) => (
          <div className="stat reveal" key={l}>
            <b>{n}</b>
            <span>{l}</span>
          </div>
        ))}
      </div>
    </Section>
  );
}
